import React, { useEffect, useState } from 'react'
import { PRINTABLE_WORKSHEET_SCREENS, usePrintableWorksheetsState } from 'printableWorksheets/state'
import { WorksheetCard } from '../worksheetsView/worksheetCard/worksheetCard';
import './styles.scss'
import EmptySavedWorksheets from 'apps/teacher/components/printable_worksheets/empty-saved-worksheets';
import CircleAnimation from 'apps/atoms/CircleAnimation';
import PrintableWorksheetsEvents from 'printableWorksheets/events';
import BackIcon from './back-icon.svg'

interface ISavedScreen {
  hideHeader?: boolean;
}

const SavedScreen = ({hideHeader = false}: ISavedScreen) => {

  const { savedEntityWorksheets, activeGrade, setActiveScreen, getSavedWorksheets, setSavedEntityWorksheets} = usePrintableWorksheetsState();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const goBack = () => {
    setActiveScreen(PRINTABLE_WORKSHEET_SCREENS.DEFAULT);
  }

  const initSavedWorksheets = async () => {
    setSavedEntityWorksheets([]);
    setIsLoading(true);
    await getSavedWorksheets();
    setIsLoading(false);
  }

  useEffect(() => {
    initSavedWorksheets();
    PrintableWorksheetsEvents.viewedSavedWorksheetPage({
      worksheetGrade: activeGrade
    });
  }, [])

  return (
    <div className='saved-worksheets'>
      {!hideHeader ? (
        <div className="saved-worksheets__header">
          <div className="go-back" onClick={() => goBack()}>
            <BackIcon />
          </div>
          <div className="title">Saved Worksheets</div>
        </div>
      ) : null}
      {isLoading ? (
        <div className="saved-worksheets__loading-container">
          <CircleAnimation />
        </div>
      ) : (
        <div className="saved-worksheets__list">
          {savedEntityWorksheets?.length > 0 ? savedEntityWorksheets.reverse().map((worksheet: any) => {
            return <React.Fragment key={worksheet.id}>
              <WorksheetCard 
                card={worksheet}
              />
            </React.Fragment>
          }) : (
            <div className="empty-container">
              <EmptySavedWorksheets />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SavedScreen